/** True when the page is loaded with ?demo in the URL */
const isDemo = new URLSearchParams(window.location.search).has("demo");
export default isDemo;
